/**
 * Provides consistent styling for several technical implementations of a button
 */
import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'
import classnames from 'classnames'

import { GTM_CLICK_TRACKING_PROP_NAME } from 'constants/global'
import defaultStyles from './button.css'

class Button extends PureComponent {
  render () {
    const {
      children,
      to,
      href,
      type,
      clickHandler,
      openLinkInNewTab,
      baseClassName,
      className,
      inline,
      animate,
      size
    } = this.props
    const props = {
      onClick: clickHandler,
      className: classnames(
        {
          [defaultStyles[baseClassName]]: !!baseClassName,
          [defaultStyles[size]]: !!size,
          [defaultStyles.inline]: inline,
          [defaultStyles.updating]: animate
        },
        className
      )
    }
    let component = 'button'
    if (this.props[GTM_CLICK_TRACKING_PROP_NAME]) {
      props[GTM_CLICK_TRACKING_PROP_NAME] = this.props[GTM_CLICK_TRACKING_PROP_NAME]
    }
    if (to) {
      props.to = to
      component = <Link />
    } else if (href) {
      if (openLinkInNewTab) {
        props.target = '_blank'
      }
      component = 'a'
      props.href = href
    } else {
      props.type = type
    }
    return React.createElement(component, props, children)
  }
}

Button.propTypes = {
  children: PropTypes.any.isRequired,
  baseClassName: PropTypes.string,
  to: PropTypes.string,
  href: PropTypes.string,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  clickHandler: PropTypes.func,
  className: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  openLinkInNewTab: PropTypes.bool,
  [GTM_CLICK_TRACKING_PROP_NAME]: PropTypes.string, // eslint-disable-line react/no-unused-prop-types
  inline: PropTypes.bool,
  animate: PropTypes.bool
}

Button.defaultProps = {
  clickHandler: null,
  to: null,
  href: null,
  type: 'button',
  size: null,
  className: 'button',
  baseClassName: null,
  openLinkInNewTab: false,
  [GTM_CLICK_TRACKING_PROP_NAME]: null,
  inline: false
}

export default Button
